import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
  isEnabledGafiRedirect = environment.enableGafiRedirect;
  constructor() {
    if(this.isEnabledGafiRedirect){
      window.location.href = 'https://www.gafi.gov.eg/';
    }
  }
}
